// date-fns
import { format, parseISO, formatDistanceToNow  } from 'date-fns'

export default function Date(props) {
    let formattedDate = '-';
    if (props.dataItem[props.field]) {
        formattedDate = format(parseISO(props.dataItem[props.field]), 'dd-LL-yyyy');
    }

    return (
        <td>
            { formattedDate }
        </td>
    )
};
